import BaseModel from 'Stores/BaseModel';
import ListModel from 'Stores/ListModel';
import ServiceModel from 'Stores/ServiceModel';
import { mapOrder, romanize } from 'Utils';
import axios from 'axios';

export default class ServiceCategoryModel extends BaseModel {
  id = null;
  name = '';
  image = null;
  slug = '';
  description = '';
  services: [];
  consumptionText: '';

  constructor(data = {}) {
    super();
    this.hydrate(data);
    this.services = new ListModel(data.services, ServiceModel, { categoryId: this.id });
  }

  getFootnotes = () => {
    return this.services
      .filter((service: ServiceModel) => service.footnote)
      .map((service: ServiceModel, index: number) => {
        ++index;
        return {
          id: `fn${index}`,
          number: romanize(index),
          refId: `service-fn-${service.id}`,
          serviceId: service.id,
          text: service.footnote,
        };
      });
  };

  //
  // API COMMUNICATION
  //

  saveCurrentOrder = services => {
    axios.patch(`${API_BASE_URL}/service-categories/${this.id}/`, {
      // Transform request payload to fit api requirements
      services: services.map((service, i) => {
        return {
          id: service.id,
          sortIndex: ++i,
        };
      }),
    });

    // sort this.services to match order passed via services parameter
    const sortedServices = mapOrder(
      this.services.items,
      services.map(s => s.id),
      'id'
    );
    // update this services to match new order
    this.services = new ListModel(sortedServices, ServiceModel);
  };

  static getAll = (params = {}) => {
    return axios({
      method: 'get',
      url: `${API_BASE_URL}/service-categories/`,
      params,
    }).then(res => {
      return new ListModel(res.data, ServiceCategoryModel);
    });
  };
}
